import { borderRadius, Icon, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 20px;
`;

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TitleMedium = styled.div`
  ${typographyV2.titleMd};
`;

export const StepperWrapper = styled.div`
  ${borderRadius.r2};
  width: 100%;
  height: 76px;
  border: 1px solid var(--border-soft);
  padding: 18px;
`;

export const BodySmall = styled.div`
  ${typographyV2.bodySm};
  color: var(--text-soft);
`;

export const StyledRankWrapper = styled.div`
  width: 100%;
  height: 76px;
  border: 1px solid var(--border-soft);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  ${typographyV2.bodySm};
`;

export const RankContainer = styled.div`
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const RankLabel = styled.div`
  ${typographyV2.bodySm}
  color: var(--text-soft);
`;

export const RankFlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
`;

export const TitleBase = styled.div`
  ${typographyV2.titleBase};
  margin-bottom: 8px;
`;

export const StyledIcon = styled(Icon)`
  background-color: var(--kg-brand);
`;
